module.exports = __webpack_public_path__ + "img/gaming.c6f23ed3.png";